import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  profilePhoto: null
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    setProfilePhoto: (state, action) => {
      state.profilePhoto = action.payload;
    },
    removeProfilePhoto: (state) => {
      state.profilePhoto = null;
    }
  }
});

export const { setProfilePhoto, removeProfilePhoto } = userSlice.actions;
export default userSlice.reducer;